const VesselPattern = ({ className = "", stroke = "#C8A46A", opacity = 0.08 }) => (
  <svg className={className} aria-hidden="true">
    <defs>
      <pattern
        id="hv-vessel-grid"
        width="64"
        height="64"
        patternUnits="userSpaceOnUse"
      >
        <path
          d="M0 0 L64 64 M64 0 L0 64"
          fill="none"
          stroke={stroke}
          strokeOpacity={opacity}
          strokeWidth="1"
        />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#hv-vessel-grid)" />
  </svg>
);

export default VesselPattern;
